// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__9TYGb","rootCenter":"LoadMoreObserver_rootCenter__1I5r8","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__f-5zM"};